module.exports = __webpack_public_path__ + "static/img/LZD2.21408a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/country/LZD2.png
// module id = KURG
// module chunks = 1